// import images from '../../../common/images'
import type LeadershipDto from './LeadershipDto'

export const managers: LeadershipDto[] = [
  {
    name: 'アラン・ファン',
    position: '執行役員 ',
    enPosition: 'CTO',
    intro:
      '1995年生まれ。中国にて大学卒業後、スタートアップ複数社で経験を積んだ後、Teslaに入社。AIチームのシニアエンジニア兼PMを務め、複数のAIプロジェクトの立ち上げを主導した後、生成AIスタートアップMidjourneyにて画像生成AIの開発に従事。25年4月より執行役員CTOとしてIVA株式会社に参画。中国語、英語のバイリンガル。',
    profile: require('../../../images/vp-allan.png')
  },
  {
    name: '玉野 菫',
    position: '執行役員 ',
    enPosition: 'VP of Business Development',
    intro:
      '金融機関を経て2021年8月IVAに参画。AI真贋鑑定サービス「FAKEBUSTERS」のパートナー企業・コンシューマ双方に向けたカスタマーサクセス領域を中心に、Generalistとして幅広い業務に従事。2025年3月、VP of Business Developmentに就任。',
    profile: require('../../../images/vp-tamano.jpg')
  },
  // {
  //   name: '丸岡 一勝',
  //   position: '執行役員',
  //   enPosition: 'VP of Corporate',
  //   intro:
  //     '早稲田大学大学院会計研究科卒業。株式会社Fablic（現楽天）など複数のスタートアップで管理部長やCFOとして資金調達、IPO準備、社内管理体制構築を実施。2024年10月IVAに参画。 VP of Corporateに就任。',
  //   profile: require('../../../images/vp-maruoka.jpg')
  // },
  {
    name: '小礒 雅',
    position: '執行役員 ',
    enPosition: 'VP of Logistics',
    intro:
      '総合物流企業にて輸出入業務、物流センター業務、中国現地法人の立ち上げを経験した後、複数の中国・香港現地法人の管理・運営、国内・国際物流の営業部門に携わる。2025年4月IVAに参画。VP of Logisticsに就任。',
    profile: require('../../../images/vp-koiso.jpg')
  },
  {
    name: '塩澤 源太',
    position: '執行役員 ',
    enPosition: 'VP of PDX',
    intro:
      'オンスクリーンメディアのアートディレクション、メディア事業統括を経験し、コンサルファームにて新規事業開発におけるUXDに携わる。2023年3月IVAに参画し、プロダクト/コーポレートのブランディングやUI/UXデザインを統括。2025年3月、VP of PDXに就任。',
    profile: require('../../../images/vp-gen.jpg')
  },
  {
    name: '松本 健吾',
    position: '執行役員 ',
    enPosition: 'VP of Store',
    intro:
      'アパレル業界にてIPに関わる企画・デザインおよび生産管理を経験。2023年5月IVAに参画し、複数部署における業務改革やオペレーション設計、サービス改善プロジェクトを推進するなど、事業基盤の強化に従事。2026年7月、VP of Storeに就任。',
    profile: require('../../../images/vp-matsumoto.jpg')
  }
]
